import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const contractRoleFilterLabel = () => t({ message: 'Contract role', comment: 'Insights filter: Contract role' });
export function ContractRoleFilter() {
    return (<MetadataAllowedValuesFilter name="ContractRole" field="metadataDocumentContractRole" label={contractRoleFilterLabel()}/>);
}
